import React, { useState, useEffect } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';

//iconos
import { Assignment, Create } from '@material-ui/icons';

//tabla y card components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import Button from 'components/CustomButtons/Button.js';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

import Modal from './Modal';
import { useModal } from 'hooks/useModal';

//servicios
import { wsGetAll, wsFindBy } from 'services/WService.js';

import { Toasty, useToasty } from 'hooks/Toasty';
import ButtonDelete from 'hooks/ButtonDelete';
import { Autocomplete } from '@material-ui/lab';
import { Divider, TextField } from '@material-ui/core';
import { WithApp } from 'contexts/appContext';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
};
const useStyles = makeStyles(styles);

//columnas para llenar la tabla
const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false },
  { Header: 'Cód. Cliente', accessor: 'codCustomer' },
  { Header: 'Cliente', accessor: 'customer' },
  { Header: 'Domicilio Id', accessor: 'codAddress' },
  { Header: 'Cód. Ruta', accessor: 'codeRoute' },
  { Header: 'Ruta', accessor: 'route' },
  { Header: 'Cód. Mesa', accessor: 'codBureau' },
  { Header: 'Mesa', accessor: 'bureau' },
  { Header: 'Canal', accessor: 'canal' },
  { Header: 'Estado', accessor: 'state' },
  { Header: '', accessor: 'actions', excelEnabled: false }
];

export default WithApp(function CustomerBureau(props) {
  const classes = useStyles();

  const [notify, showNotify] = useToasty(); //notificación despues de las acciones
  const [model, setOpen] = useModal(); //uso de las funciones del modal

  const [customerBs, setCustomerBs] = useState([]); //constante para el listado

  //#region listados para usar en los filtro
  const [customers, setCustomers] = useState([]);
  const [routes, setRoutes] = useState([]);
  const [bureaus, setBureaus] = useState([]);
  const [canals, setCanals] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);

  async function listCustomers(inputValue) {
    let lazyEvent = {
      first: null,
      rows: null,
      filters: {
        CardType: [
          {
            value: 'C',
            matchMode: 'equals',
            operator: 'and'
          }
        ],
        CardCode: [
          {
            value: inputValue,
            matchMode: 'contains',
            operator: 'and'
          }
        ],
        CardName: [
          {
            value: inputValue,
            matchMode: 'contains',
            operator: 'or'
          }
        ]
      }
    };

    let response = await wsFindBy('base/business-partner', {
      lazyEvent: JSON.stringify(lazyEvent)
    });
    if (response.success) setCustomers(response.data);
  }

  async function listRoutes(inputValue) {
    let lazyEvent = {
      first: null,
      rows: null,
      filters: {
        code: [
          {
            value: inputValue,
            matchMode: 'contains',
            operator: 'or'
          }
        ],
        description: [
          {
            value: inputValue,
            matchMode: 'contains',
            operator: 'or'
          }
        ]
      }
    };

    let response = await wsFindBy('base/route', { lazyEvent: JSON.stringify(lazyEvent) });
    if (response.success) setRoutes(response.data);
  }

  async function listBureaus() {
    setDataLoading(true);
    let response = await wsGetAll('base/bureau');
    setDataLoading(false);
    if (response.success) setBureaus(response.data);
  }

  async function listCanals() {
    setDataLoading(true);
    let response = await wsGetAll('base/canal');
    setDataLoading(false);
    if (response.success) setCanals(response.data);
  }

  //#endregion

  const [filter, setFilter] = useState({});
  function handleChange(field, value) {
    setFilter({
      ...filter,
      [field]: value
    });
  }

  //recargar Listado para usar en create y update
  async function loadCustomerBs(filter) {
    for (var clave in filter) {
      if (filter[clave] == null) {
        delete filter[clave]; //eliminamos las claves nulas
      }
    }
    setDataLoading(true);
    let response = await wsFindBy('base/customer-bureau', filter);
    setDataLoading(false);
    if (response.success) setCustomerBs(response.data);
  }

  useEffect(() => {
    loadCustomerBs(filter);
    listBureaus();
    listCanals();
  }, [filter]);

  return (
    <GridContainer>
      <Toasty action={notify} />
      <Modal
        model={model}
        setOpen={setOpen}
        showNotify={showNotify}
        reload={() => loadCustomerBs(filter)}
        canals={canals}
      />

      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <CardIcon color="primary">
              <Assignment />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>Listado de Cliente Mesa{dataLoading && <LoadingSpinner />}</h4>
          </CardHeader>
          <CardBody>
            <GridContainer>
              <GridItem xs={12} lg={3} xl={3}>
                <Autocomplete
                  options={customers}
                  getOptionLabel={(option) => `${option.CardCode} - ${option.CardName}`}
                  clearOnBlur={false}
                  noOptionsText="Mínimo 4 caracteres"
                  defaultValue={undefined}
                  renderInput={(params) => <TextField {...params} label="Cliente" />}
                  onInputChange={(e) => {
                    if (e.target.value?.length > 3) {
                      listCustomers(e.target.value);
                    } else {
                      setCustomers([]);
                    }
                  }}
                  onChange={(e, item) => {
                    if (!!item) {
                      return handleChange('base_business_partner_id', item.id);
                    }
                    handleChange('base_business_partner_id', null);
                  }}
                />
              </GridItem>
              <GridItem xs={12} lg={3} xl={3}>
                <Autocomplete
                  options={routes}
                  getOptionLabel={(option) => `${option.code} - ${option.description}`}
                  clearOnBlur={false}
                  noOptionsText="Mínimo 4 caracteres"
                  defaultValue={undefined}
                  renderInput={(params) => <TextField {...params} label="Ruta" />}
                  onInputChange={(e) => {
                    if (e.target.value?.length > 3) {
                      listRoutes(e.target.value);
                    } else {
                      setRoutes([]);
                    }
                  }}
                  onChange={(e, item) => {
                    if (!!item) {
                      return handleChange('base_route_id', item.id);
                    }
                    handleChange('base_route_id', null);
                  }}
                />
              </GridItem>
              <GridItem xs={12} lg={3} xl={3}>
                <Autocomplete
                  options={bureaus}
                  getOptionLabel={(option) => `${option.code} - ${option.description}`}
                  clearOnBlur={false}
                  defaultValue={undefined}
                  renderInput={(params) => <TextField {...params} label="Mesas" />}
                  onChange={(e, item) => {
                    if (!!item) {
                      return handleChange('base_bureau_id', item.id);
                    }
                    handleChange('base_bureau_id', null);
                  }}
                />
              </GridItem>
              <GridItem xs={12} lg={3} xl={3}>
                <Autocomplete
                  options={canals}
                  getOptionLabel={(option) => `${option.code} - ${option.description}`}
                  clearOnBlur={false}
                  defaultValue={undefined}
                  renderInput={(params) => <TextField {...params} label="Canal" />}
                  onChange={(e, item) => {
                    if (!!item) {
                      return handleChange('base_canal_id', item.id);
                    }
                    handleChange('base_canal_id', null);
                  }}
                />
              </GridItem>
            </GridContainer>
            <br />
            <ReactTable
              excelName="Cliente-mesa"
              defaultWidth={2000}
              indexRow={[0, 1, 3, 4, 5, 6, 7, 8, 9, 10]}
              widthRow={[120, 150, 150, 150, 350, 150, 300, 150, 150, 5]}
              columns={columns}
              data={customerBs.map((customerB, i) => {
                return {
                  num: (
                    <div className="actions-right">
                      {i + 1}
                      <AllowedGuard permission={ConstantPermissions.BASE_CUSTOMER_BUREAUS_DELETED}>
                        <ButtonDelete
                          entity="base/customer-bureau"
                          id={customerB.id}
                          reload={() => loadCustomerBs(filter)}
                        />
                      </AllowedGuard>

                      <AllowedGuard permission={ConstantPermissions.BASE_CUSTOMER_BUREAUS_UPDATE}>
                        <Button
                          justIcon
                          round
                          simple
                          color={props.themeContext.buttonColorWarning}
                          onClick={() => setOpen(customerB)}
                        >
                          <Create />
                        </Button>
                      </AllowedGuard>
                    </div>
                  ),
                  codCustomer: customerB.CardCode,
                  customer: customerB.CardName,
                  codAddress: customerB.Address,
                  codeRoute: customerB.base_route_code,
                  route: customerB.base_route_description,
                  codBureau: customerB.base_bureau_code,
                  bureau: customerB.base_bureau_description,
                  canal: customerB.base_canal_description,
                  state: customerB.state === 'A' ? 'Activo' : 'Inactivo',
                  actions: ''
                };
              })}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
});
